import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { CircularProgress } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import warehouseService from "services/admin/warehousesService";
import AppAdminTable from "components/AppAdminTable/AppAdminTable";
import { toDate } from "helpers/dateHelper";

const WarehouseList = () => {
    const columnConfig = [
        {
            key: "#",
            label: "#",
            render: (v, i) => i + 1,
        },
        {
            key: "name",
            label: "Название"
        },
        {
            key: "cityID",
            label: "Город",
            render: (w) => w.city?.name,
        },
        {
            key: "address1",
            label: "Адрес",
        },
        {
            key: "createdAt",
            label: "Дата создания",
            formatter: (v) => toDate(v)
        },
        {
            key: "updatedAt",
            label: "Дата обновления",
            formatter: (v) => toDate(v)
        },
    ]

    const [data, loadData, loading, error] = useRemoteResource(warehouseService.getAll, "");

    const onDelete = async (item) => {
        await warehouseService.delete(item.id);
        loadData();
    };

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.data.length === 0) {
            return <div>Точки продаж отсутсвуют. Чтобы добавить точку продаж пожалуйста, нажмите на кнопку "Добавить" сверху</div>
        }
        if (data.data.length > 0) {
            return <AppAdminTable data={data.data} columnConfig={columnConfig} onDelete={onDelete} />
        }
    }
    return (
        <ListPage pageTitle="Список точек продаж">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(WarehouseList);
